import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { LorenExpansionPanelComponent } from "./components/loren-expansion-panel/loren-expansion-panel.component";

@NgModule({
  declarations: [LorenExpansionPanelComponent],
  exports: [LorenExpansionPanelComponent],
  imports: [
    CommonModule,
    MatExpansionModule,

    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
  ],
})
export class LorenExpansionPanelModule {}
